import { combineReducers } from 'redux';

import { busylightReducer } from 'app/views/layout/views/settings/views/preferences/views/busylight/busylight.reducer';
import { profileReducer } from 'app/views/layout/views/settings/views/profile/settingsProfile.reducer';

import { organization as organizationV2 } from '../organization/reducers/organization';

import { chatWidget } from './sections/chatWidgets';
import { customCards } from './sections/customCards';
import { email } from './sections/email';
import { magentoCards } from './sections/magentoCards';
import { organization } from './sections/organization';
import { personal } from './sections/personal';
import { queues } from './sections/queues';
import { salesforceCards } from './sections/salesforceCards';
import { satisfaction } from './sections/satisfaction';
import { shopifyCards } from './sections/shopifyCards';
import { telephony } from './sections/telephony';
import { templates } from './sections/templates';

const reducer = combineReducers({
  profile: profileReducer,
  organization,
  organizationV2,
  queues,
  telephony,
  chatWidget,
  personal,
  email,
  customCards,
  shopifyCards,
  magentoCards,
  salesforceCards,
  satisfaction,
  templates,
  busylight: busylightReducer,
});

export default reducer;
